import {Checkbox as PeacockCheckbox} from '@pepsico-ds/ui'

/** @typedef {import('@pepsico-ds/ui').ICheckboxProps} CheckboxProps */

/** Wrapper around Peacock DS Checkbox. @param {CheckboxProps} props */
export const Checkbox = props => <PeacockCheckbox {...props} />
